import React, { useEffect } from 'react'
import ClosePopupButton from './ClosePopupButton'

const PopupContent = ({children, addClassToBackdrop, addClassToPopup, translation, onClosePopup}) => {
    useEffect(() => () => onClosePopup('force'), [])

    return (
        <div className={(addClassToBackdrop ? addClassToBackdrop + " " : "") + "popup has-popup-close"} onClick={onClosePopup}>
            <div className={(addClassToPopup ? addClassToPopup + " " : "") + "popup-content theme-radius-posters-full"}>
                <div className="popup-content-wrapper">
                    {children}
                </div>
                <ClosePopupButton 
                    translation={translation}
                    onClosePopup={onClosePopup} 
                /> 
            </div>
        </div>
    )
}

export default PopupContent